export default {
  whatsAppVoiceDialog: {
    title: 'Chamada de WhatsApp',
    statusMessage: {
      reject:
        'Esse contato ainda não autorizou o recebimento de chamadas via WhatsApp ou teve sua sessão expirada. Deseja enviar um template para solicitar a autorização?',
      pending:
        'Aguardando autorização do contato para poder realizar chamadas de voz via WhatsApp.',
      permanent: 'Iniciar chamada via grupo de WhatsApp',
      temporary: 'Iniciar chamada via grupo de WhatsApp',
    },
    groupSelectLabel: 'Selecione o grupo de WhatsApp',
    sendTemplateText: 'ENVIAR TEMPLATE',
    cancelText: 'CANCELAR',
    callText: 'CHAMAR',
  },
};
